import firebase from "firebase/app";
// Required for side-effects
require("firebase/firestore");
require("firebase/functions");

let initialized = false;
export default (config) => {
  if (initialized) return firebase;
  initialized = true;
  firebase.initializeApp(config);
  const settings = { /* your settings... */ timestampsInSnapshots: true };
  firebase.firestore().settings(settings);
  return firebase;
};
